<template>
  <div class="inner-content">
    <div
      class="submitted-content--bold mt-10"
      v-html="
        t(
          'OrderInfo_information_on_next_steps'
        )
      "
    />
    <div
      v-html="
        t(
          'OrderInfo_send_samples_to_address'
        )
      "
    />
    <div
      v-html="
        t(
          'OrderInfo_address'
        )
      "
    />
    <div
      class="mt-10"
      v-html="
        t(
          'OrderInfo_download_consent'
        )
      "
    />
    <div>
      <OrderConsentDownload />
    </div>
    <div
      class="submitted-content--bold mt-10"
      v-html="
        t('OrderInfo_information_on_the_further_process')
      "
    />
    <div
      v-html="
        t(
          'OrderInfo_once_we_have_received_your_complete_order'
        )
      "
    />
    <div
      v-html="
        t(
          'OrderInfo_you_will_receive_a_notification'
        )
      "
    />
    <div
      class="submitted-content--bold mt-10"
      v-html="
        t('OrderInfo_need_help')
      "
    />
    <div
      v-html="
        t(
          'OrderInfo_in_case_of_any_questions'
        )
      "
    />
  </div>
</template>

<script setup lang="ts">
import OrderConsentDownload from "@/components/orders/OrderConsentDownload.vue";
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
</script>
